module.exports = __webpack_public_path__ + "static/media/eHealth_Africa_Logo.6c0d1a1e.svg";